import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { APP_CONFIG } from "../../../core/config/app-config";
import {
    ShopPrice,
    ShopProduct,
    ShopProductApiResponse,
} from "../models/shop.models";

@Injectable({ providedIn: "root" })
export class ShopApiService {
    private readonly http = inject(HttpClient);
    private readonly productsUrl = `${inject(APP_CONFIG).apiBaseUrl}/servpaysys/pay/products`;

    loadProducts(): Observable<ShopProduct[]> {
        return this.http.get<ShopProductApiResponse[]>(this.productsUrl).pipe(
            map((products) =>
                products
                    .filter((product) => product.active !== false)
                    .map((product) => this.mapProduct(product))
                    .filter((product) => product.prices.length > 0)
            )
        );
    }

    private mapProduct(product: ShopProductApiResponse): ShopProduct {
        const category =
            product.category === "core" || product.metadata?.category === "core"
                ? "core"
                : "addon";
        const allowMultiple = product.metadata?.allow_multi === "true";
        const productName = product.name || "Subscription option";
        return {
            productId: product.id,
            name: productName,
            description: product.description,
            category,
            allowMultiple,
            prices: (product.prices ?? [])
                .filter((price) => price.active !== false)
                .map(
                    (price): ShopPrice => ({
                        priceId: price.id,
                        productId: product.id,
                        productName,
                        nickname:
                            price.nickname ||
                            price.lookupKey ||
                            price.lookup_key ||
                            productName,
                        lookupKey: price.lookupKey ?? price.lookup_key ?? "",
                        unitAmount: price.unitAmount ?? price.unit_amount ?? 0,
                        currency: price.currency || "eur",
                        interval: price.recurring?.interval,
                        type: price.type ?? "recurring",
                        category,
                        allowMultiple:
                            price.metadata?.allow_multi === "true" ||
                            allowMultiple,
                    })
                ),
        };
    }
}
